import React from 'react';

const CheckBox = ({id, handleOnClick, checked, enable, children, readOnly, idx, type}) => {
  const handleOnCheckClick = (e) => {
    if(handleOnClick) handleOnClick(e, type, idx);
  }

  const htmlId = `${id}_id`;

  return (
    <div className='item'>
        <input type="checkbox" value="off" id={htmlId} disabled={enable} checked={checked} readOnly={readOnly}
                onChange={handleOnCheckClick} key={`${id}_check`}/>
        <label className="checkbox" key={`${id}_label`}
                    htmlFor={htmlId}>{children}</label>
    </div>
    );
    
}

export default CheckBox;


// WEBPACK FOOTER //
// ./src/components/checkbox/index.js